import { AsyncValidationOptions } from 'joi';
import { joi } from '@qualifio/ui-commons/src/i18n/locales/en.json';
import { joiTranslations } from '@loyalty/translations';

export const joiOptions: AsyncValidationOptions = {
  abortEarly: true,
  stripUnknown: true,
  convert: true,
  presence: 'required',
  errors: {
    language: 'en',
  },
  messages: { ...joi, ...joiTranslations.en },
};
